import BasicUserInfoService from '@/services/user/BasicUserInfoService'

const localInfo = JSON.parse(localStorage.getItem('basicUserInfo'))

const initialState = localInfo || {
  userName: '',
  firstName: '',
  lastName: '',
  initials: '??',
  email: '',
  phone: '',
  canEditCodebooks: false,
  hasAnyCollection: false
}

export default {
  namespaced: true,
  state: initialState,
  getters: {
    userName: state => state.userName,
    firstName: state => state.firstName,
    lastName: state => state.lastName,
    initials: state => state.initials,
    email: state => state.email,
    phone: state => state.phone,
    canEditCodebooks: state => state.canEditCodebooks,
    hasAnyCollection: state => state.hasAnyCollection
  },
  actions: {
    refreshBasicUserInfo ({ commit }) {
      return BasicUserInfoService.getBasicUserInfo().then(userInfo => {
        localStorage.setItem('basicUserInfo', JSON.stringify(userInfo))
        commit('SET_BASIC_USER_INFO', userInfo)
      })
    },
    editBasicUserInfo ({ dispatch }, basicUserInfo) {
      return BasicUserInfoService.editBasicUserInfo(basicUserInfo).then(_ => {
        dispatch('refreshBasicUserInfo')
      })
    }
  },
  mutations: {
    SET_BASIC_USER_INFO (state, basicUserInfo) {
      state.userName = basicUserInfo ? basicUserInfo.userName : null
      state.firstName = basicUserInfo.firstName
      state.lastName = basicUserInfo.lastName
      state.initials = basicUserInfo.initials
      state.phone = basicUserInfo.phone
      state.email = basicUserInfo.email
      state.canEditCodebooks = basicUserInfo.canEditCodebooks
      state.hasAnyCollection = basicUserInfo.hasAnyCollection
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/basicUserInfo.js